export default __webpack_public_path__ + "static/media/main-logo.d19d4892.png";